/* ============================================================
   CHARACTER.JS — Page-specific scripts for character.html
   ============================================================ */

// ===== LIGHTBOX =====
const lightbox = document.getElementById('lightbox');
const lightboxImg = document.getElementById('lightbox-img');
const lightboxCaption = document.getElementById('lightbox-caption');
const galleryItems = document.querySelectorAll('.gallery-item');
let currentIndex = 0;
let lastFocused = null;

function openLightbox(index) {
  const item = galleryItems[index];
  if (!item) return;
  lastFocused = document.activeElement;
  currentIndex = index;
  lightboxImg.src = item.dataset.src;
  lightboxImg.alt = item.querySelector('img').alt;
  lightboxCaption.textContent = item.dataset.caption || '';
  lightbox.classList.add('active');
  lightbox.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  lightbox.querySelector('.lightbox__close').focus();
}

function closeLightbox() {
  lightbox.classList.remove('active');
  lightbox.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  if (lastFocused) lastFocused.focus();
}

function navigateLightbox(dir) {
  currentIndex = (currentIndex + dir + galleryItems.length) % galleryItems.length;
  const item = galleryItems[currentIndex];
  lightboxImg.src = item.dataset.src;
  lightboxImg.alt = item.querySelector('img').alt;
  lightboxCaption.textContent = item.dataset.caption || '';
}

galleryItems.forEach((item, i) => {
  item.addEventListener('click', () => openLightbox(i));
});

lightbox.querySelector('.lightbox__close').addEventListener('click', closeLightbox);
lightbox.querySelector('.lightbox__nav--prev').addEventListener('click', () => navigateLightbox(-1));
lightbox.querySelector('.lightbox__nav--next').addEventListener('click', () => navigateLightbox(1));

// Close on backdrop click
lightbox.addEventListener('click', (e) => {
  if (e.target === lightbox) closeLightbox();
});

// Keyboard navigation
document.addEventListener('keydown', (e) => {
  if (!lightbox.classList.contains('active')) return;
  if (e.key === 'Escape') closeLightbox();
  if (e.key === 'ArrowLeft') navigateLightbox(-1);
  if (e.key === 'ArrowRight') navigateLightbox(1);
  // Trap focus within lightbox
  if (e.key === 'Tab') {
    const focusable = lightbox.querySelectorAll('button');
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
});

// ===== GSAP INIT =====

if(!motionReduced){
  // Hero content entrance
  const heroTl = gsap.timeline({delay:0.3});
  heroTl
    .from('.char-hero__badge',{y:20,opacity:0,duration:0.5,ease:'expo.out'})
    .from('.char-hero__name',{y:30,opacity:0,duration:0.6,ease:'expo.out'},'-=0.4')
    .from('.char-hero__tagline',{y:20,opacity:0,duration:0.5,ease:'expo.out'},'-=0.3');

  // Bio paragraphs
  gsap.from('.char-bio__portrait',{
    x:-40,opacity:0,duration:0.7,ease:'expo.out',
    scrollTrigger:{trigger:'.char-bio',start:'top 75%'}
  });
  gsap.from('.char-bio__text',{
    y:20,opacity:0,stagger:0.1,duration:0.5,ease:'power2.out',
    scrollTrigger:{trigger:'.char-bio',start:'top 80%'}
  });

  // Stats grid
  gsap.from('.char-stat',{
    y:15,opacity:0,stagger:0.04,duration:0.4,ease:'power2.out',
    scrollTrigger:{trigger:'.char-stats',start:'top 80%'}
  });

  // Appearances list
  gsap.from('.appearance-item',{
    x:-20,opacity:0,stagger:0.06,duration:0.4,ease:'power2.out',
    scrollTrigger:{trigger:'.char-appearances',start:'top 80%'}
  });

  // Gallery items
  gsap.from('.gallery-item',{
    scale:0.95,opacity:0,stagger:0.05,duration:0.4,ease:'expo.out',
    scrollTrigger:{trigger:'.char-gallery',start:'top 85%'}
  });

  // Related cards
  gsap.from('.char-related .char-card',{
    y:20,opacity:0,stagger:0.08,duration:0.5,ease:'power2.out',
    scrollTrigger:{trigger:'.char-related',start:'top 85%'}
  });

  // Read CTA
  gsap.from('.char-read-cta__cover, .char-read-cta__heading, .char-read-cta__text, .char-read-cta .btn',{
    y:20,opacity:0,stagger:0.08,duration:0.5,ease:'power2.out',
    scrollTrigger:{trigger:'.char-read-cta',start:'top 85%'}
  });

} else {
  gsap.set('.char-hero__badge, .char-hero__name, .char-hero__tagline, .char-bio__text, .char-stat, .appearance-item, .gallery-item, .char-related .char-card, .char-read-cta__cover, .char-read-cta__heading, .char-read-cta__text',{
    opacity:1, y:0, x:0, scale:1
  });
}
